<template>
  <ibox>
    <template slot="title">口コミ一覧</template>
    <template slot="tools">
    </template>
    <template slot="body">
      <div class="row" style="margin-bottom: 20px">
        <div class="col-lg-12">
          <h3>1.口コミを選択</h3>
          <div class="selectBox">
            <div class="split">
              <div class="splitTitle">
                口コミ
              </div>
              <div class="scroll">
                <template v-for="review in beforeReviews">
                  <!--                  <div class="vSelect" @click="viewReviewId = review.review_id">-->
                  <div class="vSelect" @click="appendId(review.review_id)">
                    <table class="table " style="margin-bottom: 0">
                      <tr>
                        <td width="100px">会社名</td>
                        <td>{{review.company_name}}</td>
                      </tr>
                      <tr>
                        <td>プロジェクト名</td>
                        <td>{{review.project_title}}</td>
                      </tr>
                    </table>
                  </div>
                </template>
              </div>
            </div>
            <div class="split">
              <div class="splitTitle">
                口コミ(選択済)
              </div>
              <div class="scroll">
                <template v-for="review in afterReviews">
                  <div class="vSelect" @click="removeId(review.review_id)">
                    <table class="table " style="margin-bottom: 0">
                      <tr>
                        <td width="100px">会社名</td>
                        <td>{{review.company_name}}</td>
                      </tr>
                      <tr>
                        <td>プロジェクト名</td>
                        <td>{{review.project_title}}</td>
                      </tr>
                    </table>
                  </div>
                </template>
              </div>
            </div>
            <div v-if="selectReview">
              {{viewReviewId}}
              {{selectReview}}
              <table>
                口コミID:{{selectReview.review_id}}
                会社名:{{selectReview.company_name}}
                プロジェクト名:{{selectReview.project_title}}
                駅名:{{selectReview.company_station}}
              </table>
              {{selectReview.review_id}}

            </div>

          </div>
        </div>
      </div>
      <div class="row" style="margin-bottom: 20px">
        <div class="col-lg-12">
          <h3>2.会社を選択</h3>
          <div>
            <input type="text" class="m-r-md" v-model="searchCompanyName" placeholder="会社名を入力">
            <button class="btn btn-xs btn-primary" @click="searchCompany">検索</button>
            <a target="_blank" href="/company/create">新規作成</a>
          </div>
          <div class="split">
            <div class="splitTitle">
              会社
            </div>
            <div class="scroll">
              <template v-for="company in companies">
                <!--                  <div class="vSelect" @click="viewReviewId = review.review_id">-->
                <div class="vSelect" @click="selectCompanyId = company.company_id">
                  <table class="table " style="margin-bottom: 0">
                    <tr>
                      <td width="100px">会社名</td>
                      <td>{{company.name}}</td>
                    </tr>
                    <tr>
                      <td width="100px">住所</td>
                      <td>{{company.address}}</td>
                    </tr>
                  </table>
                </div>
              </template>
            </div>
          </div>

        </div>
      </div>
      <div class="row" style="margin-bottom: 20px">
        <div class="col-lg-12">
          <h3>3.更新</h3>
          <div class="split">
            <div class="splitTitle">
              対象の口コミ
            </div>
            <div class="scroll">
              <template v-for="review in afterReviews">
                <div class="vSelect">
                  <table class="table " style="margin-bottom: 0">
                    <tr>
                      <td width="100px">会社名</td>
                      <td>{{review.company_name}}</td>
                    </tr>
                    <tr>
                      <td>プロジェクト名</td>
                      <td>{{review.project_title}}</td>
                    </tr>
                  </table>
                </div>
              </template>
            </div>
          </div>
          <div class="split">
            <div class="splitTitle">
              対象の会社
            </div>

            <table class="table" v-if="selectCompany">
              <tr>
                <td>
                  会社名
                </td>
                <td>
                  {{selectCompany.name}}
                  ({{selectCompany.name_kana}})

                </td>
              </tr>
              <tr>
                <td>住所</td>
                <td>{{selectCompany.address}}</td>
              </tr>
            </table>
            <div style="text-align: center">
              <button class="btn btn-success" @click="updateCompany">レビューを更新</button>
            </div>
          </div>
        </div>
      </div>

    </template>
    <line-dashed/>
  </ibox>
</template>
<script>
  import Api from '../../../service/Api.vue'

  export default {
    data () {
      return {
        reviews: [],
        viewReviewId: 0,
        selectReviewIds: [],
        companies: [],
        searchCompanyName: '',
        selectCompanyId: 0
      }
    },
    computed: {
      beforeReviews () {
        return this.reviews.filter((review) => {
          return this.selectReviewIds.indexOf(review.review_id) === -1
        })
      },
      afterReviews () {
        return this.reviews.filter((review) => {
          return this.selectReviewIds.indexOf(review.review_id) !== -1
        })
      },
      selectReview () {
        return this.reviews.find((review) => {
          return this.viewReviewId === review.review_id
        })
      },
      selectCompany () {
        return this.companies.find((company) => {
          return this.selectCompanyId === company.company_id
        })
      }
    },
    created () {
      let params = {
        company_id: 0
      }
      if (this.$route.query.review_id || 0) {
        params = {
          review_id: this.$route.query.review_id
        }
      }
      this.$store.commit('modalShow', true)

      Api.review.search(params).then((response) => {
        this.$store.commit('modalShow', false)
        this.reviews = response.data.reviews
      })
    },
    methods: {
      appendId (id) {
        this.selectReviewIds.push(id)
      },
      removeId (id) {
        this.selectReviewIds = this.selectReviewIds.filter((reviewId) => {
          return reviewId !== id
        })
      },
      searchCompany () {
        this.$store.commit('modalShow', true)
        Api.company.search({
          name: this.searchCompanyName
        }).then((response) => {
          this.companies = response.data.companies
          this.$store.commit('modalShow', false)
        }).catch(() => {
          this.$store.commit('modalShow', false)
        })
      },
      clickCompany (company) {
        this.selectCompany = company
      },
      updateCompany () {
        if (!this.selectReviewIds.length) {
          window.alert('レビューを選択してください')
          return
        }
        if (!this.selectCompanyId) {
          window.alert('会社を選択してください')
          return
        }
        this.$store.commit('modalShow', true)

        Api.review.updateCompany({
          company_id: this.selectCompanyId,
          review_id: this.selectReviewIds
        }).then((response) => {
          this.$store.commit('modalShow', false)
          window.alert('更新しました')
        }).catch((response) => {
          this.$store.commit('modalShow', false)
          window.alert('更新に失敗しました')
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
  .selectBox {
    /*margin-top: 40px;*/
    padding-top: 40px;


  }

  .splitTitle {
    text-align: center;
    line-height: 40px;
    background-color: #efefef;
    top: 0;
  }


  .split {
    width: 50%;

    .scroll {

      height: 300px;
      overflow: scroll;

      > div {
        padding: 4px;
        border: 1px solid #efefef;
      }
    }

    float: left;
    border: 1px solid #555;

    .vSelect {
      &:hover {
        background-color: #efefef;
        cursor: pointer;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// Check.vue?5b077f61